export const lightTheme = {
  body: "#ffffff",
  text: "#101828",
  authTitle: {
    subtitle: "#475467",
  },
  input: {
    border: "#d0d5dd",
    bg: "#fcfcfc",
    label: "#344054",
    text: "#101828",
  },
  alert: {
    text: "#4E4E4E",
  },
  logButton: {
    border: "#9492FF",
    text: "#9492FF",
  },
  activate: {
    border: "#D0D5DD",
    inputBorder: "#d0d5dd",
  },
  image: 0,
  logo: "/assets/app_logo_light.png",
  cong: "/assets/cong.png",
};
